import React, { useEffect, useMemo, useState } from 'react';
import { isNativeApp } from '../utils/isNativeApp';
import { NATIVE_DEBUG_EVENT_NAME, getNativeDebugEvents } from '../utils/nativeDebugEvents';

function formatShort(evt) {
  if (!evt) return '';
  if (evt.kind === 'axios') {
    const status = evt.status ? ` ${evt.status}` : '';
    const code = evt.code ? ` (${evt.code})` : '';
    return `${evt.method}${status}${code} ${evt.url}`;
  }
  return evt.detail || evt.kind;
}

export default function NativeDebugOverlay() {
  const [last, setLast] = useState(() => getNativeDebugEvents()[0] || null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isNativeApp()) return;

    const handler = (e) => {
      if (e?.detail) setLast(e.detail);
    };

    window.addEventListener(NATIVE_DEBUG_EVENT_NAME, handler);
    return () => window.removeEventListener(NATIVE_DEBUG_EVENT_NAME, handler);
  }, []);

  const shortText = useMemo(() => formatShort(last), [last]);

  if (!isNativeApp() || !last) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 12,
        right: 12,
        bottom: 12,
        zIndex: 99999
      }}
    >
      <div
        style={{
          background: 'rgba(17, 24, 39, 0.95)',
          color: 'white',
          borderRadius: 12,
          padding: '10px 12px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ fontSize: 12, opacity: 0.9, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {shortText}
          </div>
          <button
            onClick={() => setOpen((v) => !v)}
            style={{
              border: '1px solid rgba(255,255,255,0.25)',
              background: 'transparent',
              color: 'white',
              borderRadius: 10,
              padding: '6px 10px',
              fontSize: 12
            }}
          >
            {open ? 'Chiudi' : 'Dettagli'}
          </button>
          <button
            onClick={() => setLast(null)}
            style={{
              border: '1px solid rgba(255,255,255,0.25)',
              background: 'transparent',
              color: 'white',
              borderRadius: 10,
              padding: '6px 10px',
              fontSize: 12
            }}
          >
            Ok
          </button>
        </div>

        {open && (
          <pre
            style={{
              marginTop: 10,
              fontSize: 11,
              lineHeight: 1.3,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              opacity: 0.95
            }}
          >
            {JSON.stringify(last, null, 2)}
          </pre>
        )}
      </div>
    </div>
  );
}
